import React, { useState, useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import AppRoutes from "./routes/AppRoutes";
import AdminLoader from "./components/Loader";

function App() {
  // Splash Screen Logic: Runs once per session
  const [appInitializing, setAppInitializing] = useState(() => {
    return !sessionStorage.getItem("adminAppInitialized");
  });

  useEffect(() => {
    if (!appInitializing) return;

    const timer = setTimeout(() => {
      sessionStorage.setItem("adminAppInitialized", "true");
      setAppInitializing(false);
    }, 2000); 

    return () => clearTimeout(timer);
  }, [appInitializing]);

  // 1. SHOW PREMIUM LOADER
  if (appInitializing) {
    return (
      <AdminLoader message="CONNECTING PATRA ELITE DRIVERS & CUSTOMERS..." />
    );
  }

  // 2. MAIN APP RENDER
  return (
    // <Router basename="/admin">
     <Router> 
      <Toaster
        position="top-right" 
        reverseOrder={false}
        gutter={10}
        toastOptions={{
          duration: 2000,
          style: {
            background: "#1e293b", 
            color: "#f8fafc", 
            borderRadius: "8px", 
            border: "1px solid rgba(255, 255, 255, 0.1)",
            fontSize: "13px",
            fontWeight: "500",
            fontFamily: "'Inter', system-ui, sans-serif",
            padding: "12px 20px",
            boxShadow:
              "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
            maxWidth: "400px",
          },
          // Success State (Professional Emerald)
          success: {
            duration: 3000,
            iconTheme: { primary: "#10b981", secondary: "#fff" }, // Emerald 500
            style: {
              background: "#ffffff", // White background for positive feedback
              color: "#064e3b", // Dark Green Text
              borderLeft: "4px solid #10b981",
              border: "1px solid #e2e8f0",
            },
          },
          // Error State (Urgent Red)
          error: {
            duration: 5000,
            iconTheme: { primary: "#ef4444", secondary: "#fff" }, // Red 500
            style: {
              background: "#ffffff",
              color: "#7f1d1d", // Dark Red Text
              borderLeft: "4px solid #ef4444",
              border: "1px solid #fee2e2",
            },
          },
          // Loading State (System Blue)
          loading: {
            iconTheme: { primary: "#3b82f6", secondary: "#fff" }, // Blue 500
            style: {
              background: "#ffffff",
              color: "#1e3a8a", // Dark Blue Text
              borderLeft: "4px solid #3b82f6",
              border: "1px solid #dbeafe",
            },
          },
        }}
      />

      <AppRoutes />
    </Router>
  );
}

export default App;